<script>
import CoreComponentVue from '../../../../../../../dow-platform/ui.frontend/src/dow-platform/components/core/CoreComponent.vue'

export default {
  extends: CoreComponentVue
}
</script>

<style lang="scss">
@import './related-article.scss';
</style>
